import React, { Fragment, useEffect, useState } from 'react';

import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
 
import { AccountGeneralSettings } from 'pages/account/edit/general-settings'; 
import { AccountTachoSettings } from 'pages/account/edit/tacho-settings'; 
import { AccountChangelog } from 'pages/account/edit/changelog'; 
import { AccountInternalConfiguration } from 'pages/account/edit/internal-configuration'; 
import { AccountMigration } from 'pages/account/edit/migration';
import { AccountEarnedRecognition } from 'pages/account/edit/earned-recognition';
import { AuthenticatedRoute, UserAccess, UserHasAccess } from 'components/user-access';
import { Integrations } from './integrations'; 
import { VerticalLinkGroup, Breadcrumbs } from 'components/navigation'; 
import { PageRestricted } from 'pages/errors/page-restricted'; 
import { AccountSsoConfiguration } from './sso-configuration'; 
import { AlertSettings } from 'pages/account/edit/alert-settings/AlertSettings';
import { Storage } from 'pages/account/edit/storage';
import { DocumentsService } from 'services/DocumentsService';
import { DataRetention } from 'pages/account/edit/data-retention';
import { AccountMultifactorAuthentication } from 'pages/account/edit/security';

export function Account(props) {
    var [currentRoute, setCurrentRoute] = useState([]);
    var [storageActions, setStorageActions] = useState([]);

    useEffect(() => {
        DocumentsService.getDocumentOptions()
            .then((options) => {
                var featureActions = options.documentAreas
                    .flatMap(a => a.featureEnabledDocumentTypes.map(f => f.actionKey));
                setStorageActions([...featureActions, 'Documents:Manage']);
            });
    }, [])

    var routes = [
        { location: "/account/general-settings", title: "General Settings" },
        { location: "/account/tacho-settings", title: "Tacho Settings" },
    ];

    if (UserHasAccess("Integrations:Manage")) {
        routes.push({ location: "/account/integrations", title: "Integrations" })
    }

    if (UserHasAccess("TachoAlerts:Manage")) {
        routes.push({ location: "/account/alert-settings", title: "Alert Settings" }); 
    }

    if (UserHasAccess("Performance:Manage")) {
        routes.push({ location: `${window.env.VISIONADMIN_URL}/#/perfadmin`, title: "Performance settings", externalLink: true }) 
    }

    if (UserHasAccess(storageActions)) {
        routes.push({ location: "/account/storage", title: "Storage" });
        routes.push({ location: "/account/data-retention", title: "Data Retention" });
    }

    routes.push({ location: "/account/changes", title: "History" });

    if (UserHasAccess("internal")) {
        routes.push({ location: "/account/configuration", title: "Internal Configuration" });
        routes.push({ location: "/account/migration", title: "Account Migration" });
    }

    if (UserHasAccess("Internal:Super")) {
        routes.push({ location: "/account/earned-recognition", title: "Earned Recognition" });
    }

    if (UserHasAccess('SSO:Manage')) {
        routes.push({ location: '/account/sso-configuration', title: 'SSO Configuration' });
    }

    routes.push({ location: '/account/mfa', title: 'Multi-Factor Authentication'})

    let location = useLocation();

    useEffect(findCurrentRoute, [location]);

    function findCurrentRoute() {
        var result = routes.find((l) => {
            return location.pathname.indexOf(l.location) === 0;
        });

        setCurrentRoute([result]);
    }

    return (
        <UserAccess perform={["Account:Manage", "Internal"]}
                yes={() => (
                    <Fragment>
                        <div className="row">

                            <Breadcrumbs items={props.breadcrumbs.concat(currentRoute)} />

                            <h1>Account Settings</h1>
                            <div className="intro-text">
                                <p>In this section you can configure your account settings to suit the different services provided by Logistics UK.</p>
                            </div>
                        </div>

                        <div className="layout-cols">
                            <div className="col side-col">
                                <div className="row">
                                    <VerticalLinkGroup links={routes} exactRouteMatch={false}></VerticalLinkGroup>
                                </div>
                            </div>
                            <div className="col content-col">
                                <Routes>
                                    <Route path="general-settings" element={<AccountGeneralSettings />} />
                                    <Route path="" element={<Navigate to="/account/general-settings" replace />} />
                                    <Route path="tacho-settings" element={<AccountTachoSettings />} />
                                    <Route path="alert-settings/*" element={<AlertSettings />} />
                                    <Route path="integrations/*" element={<Integrations />} />
                                    <Route path="storage/*" element={<Storage />} />
                                    <Route path="data-retention" element={<DataRetention />} />
                                    <Route path="changes" element={<AccountChangelog />} />
                                    <Route path="configuration" element={<AuthenticatedRoute action="Internal"><AccountInternalConfiguration /></AuthenticatedRoute>} />
                                    <Route path="migration" element={<AuthenticatedRoute action="Internal"><AccountMigration /></AuthenticatedRoute>} />
                                    <Route path="earned-recognition" element={<AuthenticatedRoute action="Internal:Super"><AccountEarnedRecognition /></AuthenticatedRoute>} />
                                    <Route path="sso-configuration" element={<AuthenticatedRoute action="SSO:Manage"><AccountSsoConfiguration /></AuthenticatedRoute>} />
                                    <Route path="mfa" element={<AccountMultifactorAuthentication />} />
                                </Routes>
                            </div>


                        </div>
                    </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
            />
      
    );

}